/** @jsx jsx */
import { jsx } from 'theme-ui'

export const Uswitch = ({ width = '136', height = '135' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 136 135"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.6"
      d="M0.623133 49.381L49.9473 134.911L135.379 85.5305L86.055 -2.9629e-05L0.623133 49.381Z"
      fill="#50F094"
    />
    <path
      opacity="0.8"
      d="M86.0523 134.914L135.376 49.3837L49.9446 0.00265115L0.620437 85.5331L86.0523 134.914Z"
      fill="#50F094"
    />
    <path
      d="M117.326 18.0772H18.6772V116.839H117.326V18.0772Z"
      fill="#141414"
    />
    <path
      d="M40.0249 75.0246V33.2927H52.6997V75.1192C52.6997 85.6468 58.4264 90.628 68.0015 90.628C77.5767 90.628 83.3034 85.6468 83.3034 75.1192V33.2927H95.9782V75.0246C95.9782 92.4137 85.1816 101.624 68.0015 101.624C50.8215 101.624 40.0249 92.4137 40.0249 75.0246Z"
      fill="white"
    />
  </svg>
)

export const BT = ({ width = '60', height = '60' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.999 0C13.471 0 0.0734863 13.4305 0.0734863 29.999C0.0734863 46.5676 13.471 60 29.999 60C46.5269 60 59.9264 46.5676 59.9264 29.999C59.9264 13.4305 46.5269 0 29.999 0ZM29.9852 3.69898C44.4932 3.69898 56.2542 15.4889 56.2542 30.0325C56.2542 44.576 44.4932 56.3659 29.9852 56.3659C15.4773 56.3659 3.71631 44.576 3.71631 30.0325C3.71631 15.4889 15.4773 3.69898 29.9852 3.69898Z"
      fill="#141414"
    />
    <path
      d="M15.0842 19.7444V40.1694H23.3747C27.1428 40.1694 30.0382 37.811 30.0382 34.0759C30.0382 30.7816 27.4729 29.525 27.4729 29.525C27.4729 29.525 29.4415 28.2647 29.4415 25.462C29.4415 22.2065 26.8776 19.7444 23.0961 19.7444H15.0842ZM19.6692 23.7366H22.1186C23.8595 23.7366 24.6191 24.6336 24.6191 25.7414C24.6191 26.9441 23.7591 27.7031 22.2344 27.7031H19.6692V23.7366ZM19.6692 31.7955H22.1186C23.8595 31.7955 24.6191 32.6926 24.6191 33.8005C24.6191 35.0032 23.7591 35.7621 22.2344 35.7621H19.6692V31.7955ZM36.1873 40.1056V24.4283H31.6024V19.7062H45.8596V24.4283H41.0863V40.1056H36.1873Z"
      fill="#141414"
    />
  </svg>
)
